import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../../../context/AuthContext';
import Swal from 'sweetalert2'
import QuestionContents from './UI/QuestionContents';
import ReactPlayer from 'react-player'
import ReactDOM from 'react-dom';
import { useParams } from "react-router-dom";
import axios from "axios";

import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './matchcss.css';

const RealMatch = (props) => {

    const [msg, setMsg] = useState([]);
    const { user } = useAuth();
    const [question, setQuestion] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [userAnswers, setUserAnswers] = useState([]);
    const [leftItems, setLeftItems] = useState([]); // type: 0
    const [rightItems, setRightItems] = useState([]); // type: 1
    const [blurredIds, setBlurredIds] = useState([]);
    const [lastDrop, setLastDrop] = useState(null);
    const [subjectName, setSubjectName] = useState("");
    const params = useParams();
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;

    const getSubject = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.data['success']) {
                    setSubjectName(res.data['data']['subjects'][params['subjectid'] - 1]['subjectName'] + " - " + res.data['data']['subjects'][params['subjectid'] - 1]['subjectDesc'])
                }
            });
        } catch (err) {
            console.log();
        }
    };
    const Request = async (userAnswer) => {
        let ans = ""
        if (userAnswer) {
            ans = props.data.answer;
        }
        else {
            ans = "hatali cevap";
        }
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";
            await axios({
                method: 'GET',
                url: url,
                params: {
                    questionId: parseInt(props.questionNumber),
                    answer: ans
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data['success']) {
                    let audio = new Audio("https://api.heryerdeingilizce.com/sound/d6350096-7457-46bc-bcaa-313a33970558.mp4");
                    audio.play();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: "Doğru Cevap: " + res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        } catch (err) {
            alert(err.message);
            setMsg(err.message);
        }
    };


    const renderContent = (item) => {
        if (item.service && item.service.trim() !== "") return <div><strong>{item.service}</strong></div>;
        if (item.photo) return <img src={item.photo} alt="" style={{ width: '100%', height: 'auto', maxHeight: '200px', objectFit: 'contain' }} />;
        if (item.photourl) return <img src={item.photourl} alt="" style={{ width: '100%', height: 'auto', maxHeight: '200px', objectFit: 'contain' }} />;
        if (item.sound) return <div>

            <style>{`
    /* Tüm gereksiz ikonları gizle */
    .rhap_volume-controls,
    .rhap_additional-controls,
    .rhap_repeat-button,
    .rhap_skip-button,
    .rhap_rewind-button,
    .rhap_forward-button,
    .rhap_volume-button {
        display: none !important;
    }

    /* Player genel hizalama */
    .custom-player {
        width: 60px !important;
        height: 60px !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: none !important;    
        box-shadow: none !important;
        
    }
    /* Tek ikon gibi görünmesi için büyütme */
    .custom-player .rhap_play-pause-button {
        font-size: 40px !important;
        color: blue !important;
    }


    /* Progress bar gizle (istersen gösterebilirim) */
    .custom-player .rhap_progress-section {
        display: none !important;
    }
`}
            </style>
            <AudioPlayer
                src={item.sound}
                className="custom-player"

            />

        </div >
        if (item.soundurl) return <div>
            <style>{`
    /* Tüm gereksiz ikonları gizle */
    .rhap_volume-controls,
    .rhap_additional-controls,
    .rhap_repeat-button,
    .rhap_skip-button,
    .rhap_rewind-button,
    .rhap_forward-button,
    .rhap_volume-button,
    .rhap_time {
        display: none !important;
    }

    /* Player genel hizalama */
    .custom-player {
        width: 60px !important;
        height: 60px !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: none !important;    
        box-shadow: none !important;
        
    }
    /* Tek ikon gibi görünmesi için büyütme */
    .custom-player .rhap_play-pause-button {
        font-size: 40px !important;
        color: blue !important;
    }


    /* Progress bar gizle (istersen gösterebilirim) */
    .custom-player .rhap_progress-section {
        display: none !important;
    }
`}
            </style>
            <AudioPlayer
                src={item.soundurl}
                className="custom-player"
            />

        </div>;
        if (item.video) return <ReactPlayer url={item.video} controls={true} width="100%" height="100%" />;
        if (item.videourl) return <ReactPlayer url={item.videourl} controls={true} width="100%" height="100%" />;
        return null;
    };
    const undoLastDrop = () => {
        if (!lastDrop) return;

        // userAnswers'tan çıkar
        setUserAnswers(prev => prev.filter(ans =>
            !(ans.target === lastDrop.target && ans.source === lastDrop.source)
        ));

        // blurredIds'ten çıkar
        setBlurredIds(prev => prev.filter(id => id !== lastDrop.source));

        // DOM'dan kaldır
        if (lastDrop.element && lastDrop.element.parentNode) {
            lastDrop.element.parentNode.removeChild(lastDrop.element);
        }
        if (lastDrop.hr && lastDrop.hr.parentNode) {
            lastDrop.hr.parentNode.removeChild(lastDrop.hr);
        }

        // resetle
        setLastDrop(null);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const draggedId = e.dataTransfer.getData("text/plain");
        const draggedEl = document.getElementById(draggedId);
        const dropTarget = e.target.closest(".drop-zone");
        if (!draggedEl || !dropTarget) return;
        const targetId = parseInt(dropTarget.getAttribute("data-id"));
        const sourceItem = rightItems.find(i => (i.id + 's') === draggedId);

        // <hr> ekle
        const hr = document.createElement("hr");
        hr.style.width = "80%";
        hr.style.borderTop = "1px dashed #aaa";
        hr.style.margin = "8px 0";

        const cloned = document.createElement("div");
        cloned.classList.add("dropped-item");
        cloned.setAttribute("draggable", false);
        cloned.setAttribute("data-origin-id", draggedId);
        cloned.style.width = "100%";
        cloned.style.minHeight = "50px";
        cloned.style.height = "auto";
        cloned.style.display = "flex";
        cloned.style.alignItems = "center";
        cloned.style.justifyContent = "center";
        cloned.style.overflow = "hidden";
        cloned.style.padding = "5px";

        const mountPoint = document.createElement("div");
        cloned.appendChild(mountPoint);
        // önce <hr> sonra içerik
        if (dropTarget.children.length > 0) {
            dropTarget.appendChild(hr);
        }
        dropTarget.appendChild(cloned);

        setTimeout(() => {
            ReactDOM.render(renderContent(sourceItem), mountPoint);
        }, 0);

        // setUserAnswers(prev => [...prev, { target: targetId, source: draggedId }]);
        // setBlurredIds(prev => [...new Set([...prev, draggedId])]);

        setUserAnswers(prev => {
            const updated = [...prev, { target: targetId, source: draggedId }];
            setLastDrop({ target: targetId, source: draggedId, element: cloned, hr });
            return updated;
        });
        setBlurredIds(prev => [...new Set([...prev, draggedId])]);

    };
    const allowDrop = (e) => e.preventDefault();

    const handleSubmit = (e) => {
        e.preventDefault();
        // 1️⃣ Eksik eşleşme kontrolü
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY));
        if (userAnswers.length !== leftItems.length) {
            Swal.fire({
                icon: "warning",
                title: "Eksik Eşleştirme",
                text: "Lütfen tüm eşleştirmeleri tamamlayın"
            });
            return;
        }

        // 2️⃣ Doğru eşleşme kontrolü (ID === ID)
        const isCorrect = userAnswers.every(ans => {
            const sourceId = parseInt(ans.source.replace("s", ""));
            return ans.target === sourceId;
        });
        // 1. DENEME
        if (attempt === 0) {
            if (isCorrect) {
                Request(true);
            } else {
                localStorage.setItem(ATTEMPT_KEY, "1");

                new Audio(
                    "https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4"
                ).play();

                Swal.fire({
                    title: "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }
        // 2. DENEME
        if (isCorrect) {
            Request(true);
        }

        Request(false);





    };


    const handleDragStart = (e, id) => {
        e.dataTransfer.setData("text/plain", id);
    };
    const renewPage = async (e) => {
        e.preventDefault();
        window.location.reload();
    }


    const shuffleArray = (array) => {
        return [...array].sort(() => Math.random() - 0.5);
    };

    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }

        return () => {
            localStorage.removeItem(ATTEMPT_KEY);
        };
    }, [ATTEMPT_KEY]);

    useEffect(() => {
        getSubject();
        var questionn = JSON.parse(props.data.contentStr);
        var questionTitlee = questionn['text'].split('__')[0];
        let questionTextt = questionn['text'].split('__')[1];
        let answerss = JSON.parse(props.data.detail);
        //answerss = shuffleArray(answerss)
        setQuestion(questionn);
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
        setAnswers(answerss);
        const shuffledLeft = shuffleArray(answerss.filter(a => a.type === 0));
        const shuffledRight = shuffleArray(answerss.filter(a => a.type === 1));
        setLeftItems(shuffledLeft);
        setRightItems(shuffledRight);
    }, []);


    return (
        <div >
            <span style={{ color: "black" }}> <b><i>{subjectName}</i></b></span>
            <br />
            <b>Match Sorusu</b>
            <br />
            <div style={{ alignItems: "center", textAlign: "center", justifyContent: "center" }}>
                <QuestionContents question={question} />

                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionTitle}
                </b>
                <br />
                <b style={{ fontSize: "24px", fontFamily: 'calibri', color: "black" }}>
                    {questionText}
                </b>
                <br />
            </div>
            <div class="d-flex justify-content-center" style={{ fontSize: 20, textAlign: "center" }}>
                <form onSubmit={handleSubmit} style={{ padding: 20 }}>
                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <h4>Hedefler</h4>
                        <h4>İçerikler</h4>
                    </div> */}
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: "center", alignContent: "center" }}>
                        {leftItems.map((dt, index) => (
                            <div key={dt.id} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                {/* Hedef (sol) */}
                                <div
                                    data-id={dt.id}
                                    className="drop-zone"
                                    onDrop={handleDrop}
                                    onDragOver={allowDrop}
                                    style={{
                                        minHeight: 160,
                                        width: "180px",
                                        padding: 5,
                                        border: '2px groove #7ac1f7ff',
                                        borderRadius: 10,
                                        backgroundColor: '#f5f5f5',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: "white",
                                        padding: 5,
                                    }}
                                >
                                    {renderContent(dt)}
                                </div>
                                {/* İçerik (sağ) */}

                            </div>
                        ))}
                    </div>
                    <hr />
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: "center", alignContent: "center" }}>
                        {rightItems.map((dt, index) => (
                            <div key={dt.id} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <div
                                    key={rightItems[index].id}
                                    id={rightItems[index].id + 's'}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, rightItems[index].id + 's')}
                                    style={{
                                        minHeight: 160,
                                        width: "180px",
                                        padding: 5,
                                        border: '2px groove #7ac1f7ff',
                                        borderRadius: 10,
                                        backgroundColor: '#f5f5f5',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        placeItems: "center",
                                        justifyContent: 'center',
                                        backgroundColor: "white",
                                        padding: 5,
                                        filter: blurredIds.includes(rightItems[index].id + 's') ? 'blur(3px)' : 'none'
                                    }}
                                >
                                    {renderContent(rightItems[index])}
                                </div>
                            </div>
                        ))}
                    </div>
                    <br /><br />

                    <div class="d-flex justify-content-center">
                        <button type="button" className="undo-btn " onClick={undoLastDrop}>
                            Son İşlemi Geri Al
                        </button>
                        <button style={{ marginLeft: "3%" }} className='renew-btn' onClick={renewPage}>Yeniden Oluştur</button>
                        <button style={{ marginLeft: "3%" }} type="submit" className="save-btn">Cevapları Gönder</button>

                    </div>

                </form>
            </div >


        </div >
    );
};

export default RealMatch;